import { NON_WHITELABEL_SUBDOMAINS } from "constants/index";

const checkValidWhitelabelSubdomain = (subdomain = "") =>
  !NON_WHITELABEL_SUBDOMAINS.includes(subdomain) && !/^pr-\d+-ecs$/.test(subdomain);

export default checkValidWhitelabelSubdomain;
